export const addMemberModel = {
  name: "",
  role: "admin",
};
